import React from 'react';

import cn from 'classnames';

import { Icon, Lightbox } from '@shared/ui';

import cls from './InventoryMainImage.module.css';
import { useInventoryMainImage } from './useInventoryMainImage';

interface InventoryMainImageProps {
    previewUrl: string;
    error: string;
    onUpload: (files: File[]) => void;
}

export const InventoryMainImage = ({ previewUrl, error, onUpload }: InventoryMainImageProps) => {
    const { t, isLightboxOpen, setIsLightboxOpen, inputId, handleInputChange } =
        useInventoryMainImage(onUpload);
    const addPhotoContent = (
        <span className={cls.addPhoto}>
            <Icon iconName="fileInput" width={16} height={16} fill="#fff" />
            {t('imagePlaceholder.return')}
        </span>
    );

    return (
        <div className={cls.mainImageWrapper}>
            <input
                id={inputId}
                className={cls.fileInput}
                accept="image/*"
                type="file"
                name="file"
                multiple
                onChange={handleInputChange}
            />
            {previewUrl ? (
                <>
                    <button
                        type="button"
                        className={cls.mainImageButton}
                        onClick={() => setIsLightboxOpen(true)}
                    >
                        <img className={cls.mainImage} src={previewUrl} alt="inventory-photo" />
                    </button>
                    {isLightboxOpen && (
                        <Lightbox
                            files={[
                                {
                                    id: 1,
                                    fileSrc: previewUrl,
                                    fileName: 'inventory-photo',
                                    mimeType: 'image/jpeg',
                                },
                            ]}
                            currentFileId={1}
                            onClose={() => setIsLightboxOpen(false)}
                        />
                    )}
                </>
            ) : (
                <label
                    htmlFor={inputId}
                    className={cn(cls.mainImagePlaceholder, {
                        [cls.mainImagePlaceholderError]: Boolean(error),
                    })}
                >
                    {addPhotoContent}
                </label>
            )}
            {error && <div className={cls.imageError}>{error}</div>}
        </div>
    );
};
